import React from 'react';
import './App.scss';
import Cat from './Cat';
import Overlay from './Overlay';

function App() {
  return (
    <div className="App">
      <Cat />
      <Overlay />
    </div>
  );
}

export default App;
